import { styled } from '@mui/styles';
import { StepConnector } from '@mui/material';


export const ProgressBarConnector = styled(StepConnector)(() => ({
  marginLeft: '20px !important',
}));
